/** @jsx jsx */
import { jsx } from '@emotion/react'
import { depoimentosStyle } from '../assets/styles/Depoimentos.styles'
import { Col, Container, Row } from 'react-bootstrap'
import Depoimento1 from '../assets/images/LP-arabe/depoimentos/depoimento-1.svg'
import Depoimento2 from '../assets/images/LP-arabe/depoimentos/depoimento-2.svg'
import Depoimento3 from '../assets/images/LP-arabe/depoimentos/depoimento-3.svg'

const JornadaCompleta = () => {
  return (
    <section css={depoimentosStyle}>
      <Container>
        <Row data-aos="fade-down" data-aos-delay="500" className='title-sec'>
          <Col lg={5} md={5} sm={12}>
            <h2><span>Palavras que refletem</span> nossa missão</h2>
          </Col>
          <Col lg={2} md={2} sm={12} />
          <Col lg={5} md={5} sm={12}>
            <p>Em cada depoimento, um reflexo do nosso compromisso com a formação de crianças conectadas à fé, à cultura e ao conhecimento.</p>
          </Col>
        </Row>
        <Row data-aos="fade-down" data-aos-delay="600">
          <Col lg={4} md={4} sm={12}>
            <img src={Depoimento1} />
          </Col>
          <Col lg={4} md={4} sm={12}>
            <img src={Depoimento2} />
          </Col>
          <Col lg={4} md={4} sm={12}>
            <img src={Depoimento3} />
          </Col>
        </Row>
      </Container>
    </section>

  )
}

export default JornadaCompleta;
